import { useState } from 'react';
import { m } from 'framer-motion';

export interface SloganLineProps {
  /** visual scale: footer 'sm' (text-lg/2xl), overlay/about 'md' (text-3xl/5xl), hero 'lg' (text-4xl/7xl) */
  size?: 'sm' | 'md' | 'lg';
  /** draw the edge line + traveling light when the component enters view */
  animate?: boolean;
  className?: string;
}

const SIZE_CLASSES: Record<NonNullable<SloganLineProps['size']>, string> = {
  sm: 'text-lg md:text-2xl',
  md: 'text-3xl md:text-5xl',
  lg: 'text-4xl md:text-7xl',
};

export function SloganLine({ size = 'md', animate = true, className = '' }: SloganLineProps) {
  const [isInView, setIsInView] = useState(false);

  const textClass = `font-en font-semibold uppercase text-white ${SIZE_CLASSES[size]}`;
  const showAnimated = animate && isInView;

  return (
    <m.div
      className={`flex flex-col md:flex-row md:items-center gap-3 md:gap-6 ${className}`}
      viewport={{ once: true, amount: 0.6 }}
      onViewportEnter={animate ? () => setIsInView(true) : undefined}
    >
      <span className={`${textClass} text-left`}>FROM LIGHT</span>
      <div className={`edge-line md:flex-1${showAnimated ? ' is-animated' : ''}`} />
      <span className={`${textClass} text-right md:text-left`}>TO CREATIVE</span>
    </m.div>
  );
}
